import indexedDataEn from 'src/data/faq/en-index.json';
import dataEn from 'src/data/faq/en.json';
import indexedDataId from 'src/data/faq/id-index.json';
import dataId from 'src/data/faq/id.json';
import { useTranslate } from 'src/hooks';

const hiddenSubCategoryNameEn = [
  'Top up using VA',
  'Instant Withdrawal',
  'Manual withdrawal',
  'Top up BCA Unique Code',
  'Manual top up',
];

const hiddenSubCategoryNameId = [
  'Isi Saldo via VA',
  'Penarikan Instan',
  'Penarikan Manual',
  'Transfer Instan BCA',
  'Transfer manual',
];

const useHelpAndDocumentationData = () => {
  const { isLangEn } = useTranslate();
  const hiddenData = isLangEn
    ? hiddenSubCategoryNameEn
    : hiddenSubCategoryNameId;
  const allData = isLangEn ? dataEn : dataId;
  const allIndexedData = isLangEn ? indexedDataEn : indexedDataId;

  const data = allData.map(category => ({
    ...category,
    sub_category: category.sub_category.filter(
      sub_category => !hiddenData.includes(sub_category.name),
    ),
  }));

  const indexedData = allIndexedData.filter(
    article => !hiddenData.includes(article.subCategoryName),
  );

  function findIndexesByTitle(titleToFind: string) {
    const result = indexedData.find(data => data.title === titleToFind);
    return result
      ? {
          categoryIndex: result.categoryIndex,
          subCategoryIndex: result.subCategoryIndex,
          articleIndex: result.articleIndex,
        }
      : null;
  }

  return { data, indexedData, findIndexesByTitle };
};

export default useHelpAndDocumentationData;
